module.exports = __webpack_public_path__ + "img/layout_top_tree_left.a0a5c2d8.svg";